<template>
  <div>
    <!--<left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>-->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <!--<v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>-->
        <v-row>
          <v-col cols="12">
            <left-emp-menu></left-emp-menu>
          </v-col>
          <v-col>
            <v-row>
              <v-col cols="12">
                <v-list three-line subheader>
                  <!-- ADD -->
                  <v-dialog v-model="dialogAdd" persistent max-width="80%">
                    <v-card>
                      <v-card-title>
                        <span class="headline">เพิ่มข้อมูล</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-form
                            ref="form_add"
                            v-model="valid_add"
                            lazy-validation
                          >
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  label="เรื่องประกาศนียบัตร / คุณวุฒิพิเศษ *"
                                  v-model="formAdd.cerName"
                                  :rules="nameRules"
                                  :counter="50"
                                  maxlength="50"
                                  required
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12">
                                <v-text-field
                                  label="สถาบัน * "
                                  v-model="formAdd.cerAddress"
                                  :rules="nameRules"
                                  :counter="50"
                                  maxlength="50"
                                  required
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12">
                                <v-menu
                                  ref="menu3"
                                  v-model="menu3"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="formAdd.cerDateFrom"
                                      label="วันที่อบรม"
                                      prepend-icon="event"
                                      readonly
                                      dense
                                      outlined
                                      v-bind="attrs"
                                      v-on="on"
                                      locale="th-th"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="formAdd.cerDateFrom"
                                    locale="th-th"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="menu3 = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="$refs.menu3.save(date)"
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>

                              <v-row>
                                <v-col>
                                  <v-checkbox
                                    v-model="formAdd.cerSatus"
                                    :label="`ใบรับรองเกี่ยวกับ ใบประกาศนียบัตร: (* ถ้ามี) PDF Only`"
                                    required
                                    dense
                                  ></v-checkbox>
                                  <v-file-input
                                    v-show="formAdd.cerSatus"
                                    v-model="files"
                                    show-size
                                    accept=".pdf"
                                    counter
                                    @change="pdfupload"
                                    label="แนบไฟล์ ใบประกาศนียบัตร"
                                  ></v-file-input>
                                  <div>
                                    <pdf :src="formAdd.certificate"></pdf>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          elevation="2"
                          x-large
                          color="dark darken-1"
                          text
                          @click="(dialogAdd = false), clearData()"
                        >
                          <v-icon left> mdi-cancel</v-icon>
                          ปิด
                        </v-btn>
                        <v-btn
                          elevation="2"
                          x-large
                          color="success"
                          text
                          :disabled="!valid_add"
                          @click="addData()"
                        >
                          <v-icon left>mdi-checkbox-marked-circle</v-icon>
                          เพิ่ม
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!-- end add -->

                  <v-alert
                    v-if="dataCertificate.length == 0"
                    border="right"
                    colored-border
                    type="error"
                    elevation="20"
                  >
                    กรุณาเพิ่มข้อมูลประกาศนียบัตร อย่างน้อย 1 รายการ ( ถ้ามี * )
                    Please enter at least 1 item.
                  </v-alert>

                  <v-card-title class="header_1">
                    ประกาศนียบัตร
                    <v-icon color="#871B12">mdi-account-circle-outline </v-icon>
                    <v-spacer></v-spacer>
                    <v-col class="text-right" v-if="can">
                      <v-btn
                        v-if="dataCertificate.length <= 4"
                        color="primary"
                        depressed
                        @click="(dialogAdd = true), validate('ADD')"
                      >
                        <v-icon left>mdi-text-box-plus</v-icon>
                        เพิ่มข้อมูล
                      </v-btn>
                    </v-col>
                  </v-card-title>
                  จำนวน {{dataCertificate.length}} รายการ
                  <v-divider color="#871B12"></v-divider>

                  <div v-for="(items, index) in dataCertificate" :key="index">
                    <v-card elevation="20">
                      <v-subheader>
                        <v-col class="text-right" v-if="can">
                          <v-btn
                            small
                            color="error"
                            @click="deleteCertificate(items)"
                          >
                            <v-icon small>mdi-close</v-icon>
                            ลบข้อมูล
                          </v-btn>
                        </v-col>
                      </v-subheader>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-form
                          ref="form_update"
                          v-model="valid_update"
                          lazy-validation
                        >
                          <v-container class="py-0">
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="items.cerName"
                                  label="เรื่อง ประกาศนียบัตร / คุณวุฒิพิเศษ (*)"
                                  :rules="nameRules"
                                  :counter="50"
                                  :readonly="!can"
                                  maxlength="50"
                                  required
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12">
                                <v-text-field
                                  v-model="items.cerAddress"
                                  label="สถาบัน *"
                                  :rules="nameRules"
                                  :readonly="!can"
                                  :counter="50"
                                  maxlength="50"
                                  required
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12">
                                <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="items.cerDateFrom"
                                      label="วันที่อบรม"
                                      prepend-icon="event"
                                      readonly
                                      dense
                                      outlined
                                      v-bind="attrs"
                                      v-on="on"
                                      locale="th-th"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="items.cerDateFrom"
                                    locale="th-th"
                                    @input="menu2 = false"
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>

                              <v-row>
                                <v-col>
                                  <v-checkbox
                                    v-model="items.cerSatus"
                                    :label="`ใบรับรองเกี่ยวกับ ใบประกาศนียบัตร: (* ถ้ามี)`"
                                    required
                                    dense
                                  ></v-checkbox>
                                  <!-- <v-file-input v-if="items.cerSatus===true"
                                      v-model="files"
                                      show-size
                                      counter
                                      @change="pdfupload"
                                      label="แนบไฟล์ ใบประกาศนียบัตร"
                                    ></v-file-input> -->
                                </v-col>
                                <v-col cols="auto">
                                  <v-dialog
                                    transition="dialog-top-transition"
                                    max-width="600"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        ><v-icon>
                                          mdi-alpha-c-circle
                                        </v-icon></v-btn
                                      >
                                    </template>
                                    <template v-slot:default="dialog">
                                      <v-card>
                                        <v-toolbar color="amber lighten-2"
                                          >ใบรับรองเกี่ยวกับ
                                          ใบประกาศนียบัตร</v-toolbar
                                        >
                                        <div>
                                          <pdf
                                            :src="items.certificate"
                                          ></pdf>
                                        </div>
                                        <v-card-actions class="justify-end">
                                          <v-btn
                                            text
                                            @click="dialog.value = false"
                                            >Close</v-btn
                                          >
                                        </v-card-actions>
                                      </v-card>
                                    </template>
                                  </v-dialog>
                                </v-col>
                              </v-row>
                            </v-row>
                            <v-col cols="12" class="text-right" v-if="can">
                              <v-btn
                                color="success"
                                class="mr-0"
                                :disabled="!valid_update"
                                @click="editData(items)"
                              >
                                แก้ไขข้อมูล
                              </v-btn>
                            </v-col>
                          </v-container>
                        </v-form>
                      </v-card-text>
                    </v-card>
                    <br />
                    <br />
                  </div>
                  <br />
                </v-list>
              </v-col>
              <v-row no-gutters>
                <v-footer fixed height="60px" color="#262A34">
                  <v-col class="text-right">
                    <v-btn small color="#E0E0E0" @click="pushBack">
                      <v-icon left> mdi-arrow-left-circle-outline</v-icon>
                      ย้อนกลับ
                    </v-btn>
                    <v-btn small color="#E0E0E0" @click="pushNext">
                      หน้าถัดไป
                      <v-icon right> mdi-arrow-right-circle-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-footer>
              </v-row>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import EmpMenu from './EmployeeMenu.vue'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date
import pdf from 'vue-pdf'

export default {
  components: {
    'left-emp-menu': EmpMenu,
    // 'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    pdf
  },
  created () {
  },
  data () {
    return {
      PK: '',
      path: '/employee_cer/', // Path Model
      // Menu Config
      breadcrumbs: [],
      // End Menu Config
      dataReady: true,
      valid_add: true,
      valid_update: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu3: false,
      menu2: false,
      files: '',
      session: this.$session.getAll(),
      dialogAdd: false,

      formAdd: {
        empCode: '',
        cerName: '',
        cerAddress: '',
        cerDateFrom: '',
        certificate: '',
        cerSatus: false
      },
      dataCertificate: [],
      formUpdate: {
        empCode: '',
        cerName: '',
        cerAddress: '',
        cerDateFrom: '',
        certificate: '',
        cerSatus: false
      },
      nameRules: [(v) => !!v || 'Input is required'],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      cerID: '',
      can: true
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getGetTokenForEmployee()
    await this.checkEmpData()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async checkEmpData () {
      this.can = localStorage.getItem('CanEdit')
      this.can = (this.can === 'true')
      if (localStorage.getItem('roll') === 'Employee') {
        this.dataEmp = JSON.parse(localStorage.getItem('data'))
      } else if (localStorage.getItem('roll') === 'HR') {
        this.rollHR = true
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      } else {
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      }
      if (localStorage.getItem('roll')) {
        await this.getDataByIdCer()
      }
    },
    async getDataByIdCer () {
      this.dataCertificate = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            this.path +
            'getEmpCode?empCode=' +
            this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formUpdate, response.data)
            this.dataCertificate = response.data
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async editData (dt) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let id = dt.cerID
          let databylogin = localStorage.getItem('data')
          let ds = {
            cerName: dt.cerName,
            cerAddress: dt.cerAddress,
            cerDateFrom: dt.cerDateFrom,
            LAST_USER: databylogin.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + id,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dataReady = true
              this.getDataByIdCer()
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async addData () {
      let databylogin = localStorage.getItem('data')
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = databylogin.userName
      this.formAdd.LAST_USER = databylogin.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.empCode = this.dataEmp.empCode

      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          delete this.formAdd['cerID']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/employee_cer/" + "add",
              this.formAdd,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              if (response.status === 200) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogAdd = false
                this.dataReady = true
                this.clearData()
                this.getDataByIdCer()
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async deleteCertificate (d) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let databylogin = localStorage.getItem('data')
          let ds = {
            LAST_USER: databylogin.userName
          }

          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "delete/" + d.cerID,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.$swal('เรียบร้อย', 'ลบข้อมูล เรียบร้อย', 'success')
              this.getDataByIdCer()
              this.dataCertificate = []
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async pdfupload () {
      const _this = this
      let params = new FormData()
      _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)

      axios
        .post(this.DNS_IP + '/employee_cer/upload', params)
        .then(function (response) {
          console.log(response)
          _this.formAdd.certificate = _this.DNS_IP + '/' + response.data
        })// eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }
    },
    pushNext () {
      this.$router.push(
        '/HRM/Employee/EmployeeLanguageSkill'
      )
    },
    pushBack () {
      this.$router.push(
        '/HRM/Employee/EmployeeSso'
      )
    }
  }
}
</script>
<style scope>
.scroll {
  overflow-y: scroll;
}
.header_1 {
  font-family: Kanit;
  font-size: 20px;
  display: flex;

  color: #871b12;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeCer.vue